<p-toast></p-toast>
<div class="full-screen centrar">
    <div class="grid">
        <div style="align-items: end; display: flex;">
            <app-formulario style="width: 100%;" [formulario]="formulario" [url_imagenes_bottom]="url_imagen_bottom" [url_imagen_cabecera]="url_imagenes" (enviarFormulario)="onRecibirFormulario($event)"></app-formulario>
        </div>
        <div class="crear_usuario">
            <div style="border-top: 2px solid white; width: 100%; margin-bottom: 3%;"></div>
            <button style="background: none; border: none; color: white; font-size: 16px; cursor: pointer; padding: 0;" onclick="window.location.href='/panelAdministrador'">Volver al panel de administración</button>
            <div style="border-top: 2px solid white; width: 100%; margin-bottom: 3%;"></div>
        </div>
    </div>
</div>
